import { connect } from 'react-redux';

import { hideModal } from 'actions/ModalActions';

import PlanningDashboardTourModal from './PlanningDashboardTourModal';

const mapDispatchToProps = dispatch => ({
  closeModal: () => {
    dispatch(hideModal());
  },
});

export default connect(null, mapDispatchToProps)(PlanningDashboardTourModal);



// WEBPACK FOOTER //
// ./src/components/common/modals/PlanningDashboardTourModal/index.js